import { render, staticRenderFns } from "./NewPlay.vue?vue&type=template&id=0f47d324&scoped=true"
import script from "./NewPlay.vue?vue&type=script&lang=js"
export * from "./NewPlay.vue?vue&type=script&lang=js"
import style0 from "./NewPlay.vue?vue&type=style&index=0&id=0f47d324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47d324",
  null
  
)

export default component.exports